import React, { useEffect, useState } from "react";
import logUserAction from "./Logging";


// var selectedCategory = 'gk'; // Default category
var currentuserid = '';

// Check if the URL has a query string and extract the CategoryName if it exists
let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      // selectedCategory = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}

function navigatetoVoucherPage() {
  logUserAction(currentuserid,'Profile page: clicked Vouchers button from Voucher requests page');
  window.location.href = window.location.pathname + "?pageName=Vouchers&userid=" + currentuserid;
  return;
};

// Remove invalid useState usage here. Move userid state into the Vouchers component..

function VoucherRequests() { 
  const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; // https://kc-service-eight.vercel.app // http://localhost:3000
  console.log(KC_SERVICE);

  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(true);
  //const [userid, setUserid] = useState(() => localStorage.getItem('current_user_id') || '');

  useEffect(() => {
    async function fetchVouchers() {
      setLoading(true);
      // Use userid from state
      //alert("Fetching vouchers for user ID: " + userid);
      const response = await fetch(KC_SERVICE + '/vouchers_getopenrequests', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId: currentuserid.split('-')[0] }),
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const result = await response.json();
        //console.log('Fetched vouchers:', result);
  
        setVouchers(result.VoucherRequests || []);
      setLoading(false);
    }
    fetchVouchers();
  },[KC_SERVICE] );  // 

  // State for filters and sorting
  const [filters, setFilters] = useState({
    code: '',
    type: '',
    amount: '',
    date: '',
    status: '',
    comments:''
  });
  const [sort, setSort] = useState({ column: '', direction: 'asc' });

  // Filter and sort vouchers
  const filteredVouchers = vouchers
    .filter(voucher =>
      (filters.code === '' || (voucher.createdat ? voucher.createdat.slice(0, 4) : '-').includes(filters.createdat)) &&
      (filters.type === '' || (voucher.type || '-').toLowerCase().includes(filters.type.toLowerCase())) &&
      (filters.amount === '' || (voucher.amount ? String(voucher.amount) : '-').includes(filters.amount)) &&
      (filters.date === '' || (voucher.date ? voucher.date.slice(0, 10) : '-').includes(filters.date)) &&
      (filters.status === '' || (voucher.status || '-').toLowerCase().includes(filters.status.toLowerCase())) &&
      (filters.comments === '' || (voucher.comments || '-').toLowerCase().includes(filters.comments.toLowerCase()))
    )
    .sort((a, b) => {
      if (!sort.column) return 0;
      let aValue = a[sort.column] || '';
      let bValue = b[sort.column] || '';
      if (sort.column === 'amount') {
        aValue = Number(aValue) || 0;
        bValue = Number(bValue) || 0;
      } else {
        aValue = String(aValue).toLowerCase();
        bValue = String(bValue).toLowerCase();
      }
      if (aValue < bValue) return sort.direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return sort.direction === 'asc' ? 1 : -1;
      return 0;
    });

  // Handle filter input changes
  function handleFilterChange(column, value) {
    setFilters(prev => ({ ...prev, [column]: value }));
  }

  // Handle sorting
  function handleSort(column) {
    setSort(prev =>
      prev.column === column
        ? { column, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
        : { column, direction: 'asc' }
    );
  }

  // Calculate sum of amount for filtered vouchers
  const totalAmount = filteredVouchers.reduce(
    (sum, voucher) => sum + (Number(voucher.amount) || 0),
    0
  );

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const vouchersPerPage = 2;
  const totalPages = Math.ceil(filteredVouchers.length / vouchersPerPage);

  // Get current page vouchers
  const paginatedVouchers = filteredVouchers.slice(
    (currentPage - 1) * vouchersPerPage,
    currentPage * vouchersPerPage
  );

  // Handle page change
  function handlePageChange(newPage) {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  }

  // Reset to first page when filters or sorting change
  useEffect(() => {
    setCurrentPage(1);
  }, [filters, sort]);

  // // Calculate total amount for vouchers where type is 'myscore'
  // const myScoreTotal = vouchers
  //   .filter(voucher => (voucher.type || '').toLowerCase() === 'myscore')
  //   .reduce((sum, voucher) => sum + (Number(voucher.amount) || 0), 0);

  // // Calculate total amount for vouchers where type is 'team'
  // const myTeamScoreTotal = vouchers
  // .filter(voucher => (voucher.type || '').toLowerCase() === 'team')
  // .reduce((sum, voucher) => sum + (Number(voucher.amount) || 0), 0);

  // // Calculate total amount for vouchers where type is 'myscore'
  // const myOverallScoreTotal = vouchers
  // .reduce((sum, voucher) => sum + (Number(voucher.amount) || 0), 0);

  return (
    <div style={{ backgroundColor: 'white', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <img src="Me.png" alt="Profile Pic" style={{ display: 'block', margin: '20px auto', width: '100px', height: '100px', borderRadius: '50%', border: '0px solid blue' }} />
      <div style={{ background: '#fff', borderRadius: '8px', padding: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
          <h3>Voucher Requests</h3>
          <button
            onClick={() => navigatetoVoucherPage()}
            style={{
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            My Vouchers 
          </button>
        </div>        {loading ? (
          <div>Loading...</div>
        ) : (
          <div>
            {/* Filter Inputs */}
            <div
              style={{
                display: 'flex',
                borderBottom: '1px solid #ddd',
                padding: '4px 0',
                background: '#fafafa',
                flexWrap: 'wrap',
                gap: '4px'
              }}
            >
              <input
                style={{
                  flex: '2 1 120px',
                  minWidth: '80px',
                  padding: '4px',
                  marginRight: '2px',
                  boxSizing: 'border-box'
                }}
                placeholder="Filter Voucher"
                value={filters.code}
                onChange={e => handleFilterChange('code', e.target.value)}
              />
              <input
                style={{
                  flex: '1 1 80px',
                  minWidth: '60px',
                  padding: '4px',
                  marginRight: '2px',
                  boxSizing: 'border-box'
                }}
                placeholder="Filter Type"
                value={filters.type}
                onChange={e => handleFilterChange('type', e.target.value)}
              />
              <input
                style={{
                  flex: '1 1 80px',
                  minWidth: '60px',
                  padding: '4px',
                  marginRight: '2px',
                  boxSizing: 'border-box'
                }}
                placeholder="Filter Amount"
                value={filters.amount}
                onChange={e => handleFilterChange('amount', e.target.value)}
              />
              <input
                style={{
                  flex: '2 1 120px',
                  minWidth: '80px',
                  padding: '4px',
                  marginRight: '2px',
                  boxSizing: 'border-box'
                }}
                placeholder="Filter Comment"
                value={filters.comments}
                onChange={e => handleFilterChange('comments', e.target.value)}
              />
              <input
                style={{
                  flex: '2 1 120px',
                  minWidth: '80px',
                  padding: '4px',
                  boxSizing: 'border-box'
                }}
                placeholder="Filter status"
                value={filters.status}
                onChange={e => handleFilterChange('status', e.target.value)}
              />
            </div>
            {/* Table Header with Sorting */}
            <div style={{ display: 'flex', fontWeight: 'bold', borderBottom: '2px solid #ddd', padding: '8px 0', cursor: 'pointer' }}>
              <div
                style={{ flex: 2, padding: '8px', textAlign: 'left' }}
                onClick={() => handleSort('code')}
              >
                Created On {sort.column === 'code' ? (sort.direction === 'asc' ? '▲' : '▼') : ''}
              </div>
              <div
                style={{ flex: 1, padding: '8px', textAlign: 'left' }}
                onClick={() => handleSort('type')}
              >
                Type {sort.column === 'type' ? (sort.direction === 'asc' ? '▲' : '▼') : ''}
              </div>
              <div
                style={{ flex: 1, padding: '8px', textAlign: 'left' }}
                onClick={() => handleSort('amount')}
              >
                Amount {sort.column === 'amount' ? (sort.direction === 'asc' ? '▲' : '▼') : ''}
              </div>
              <div
                style={{ flex: 2, padding: '8px', textAlign: 'left' }}
                onClick={() => handleSort('comments')}
              >
                Comments {sort.column === 'comments' ? (sort.direction === 'asc' ? '▲' : '▼') : ''}
              </div>
              <div
                style={{ flex: 2, padding: '8px', textAlign: 'left' }}
                onClick={() => handleSort('status')}
              >
                Status {sort.column === 'status' ? (sort.direction === 'asc' ? '▲' : '▼') : ''}
              </div>
            </div>
            {filteredVouchers.length === 0 ? (
              <div style={{ padding: '16px', textAlign: 'center', color: '#888' }}>No vouchers found.</div>
            ) : (
              <>
                {paginatedVouchers.map((voucher) => (
                  <div key={voucher.id} style={{ display: 'flex', borderBottom: '1px solid #eee', padding: '8px 0', alignItems: 'center' }}>
                    <div style={{ flex: 2, padding: '8px' }}>{voucher.code || voucher.createdat.slice(0, 10) || '-'}</div>
                    <div style={{ flex: 1, padding: '8px' }}>{voucher.type || '-'}</div>
                    <div style={{ flex: 1, padding: '8px' }}>{voucher.amount ? `$${voucher.amount}` : '-'}</div>
                    <div style={{ flex: 2, padding: '8px' }}>{voucher.comments ? voucher.comments : '-'}</div>
                    <div style={{ flex: 2, padding: '8px' }}>{voucher.status || '-'}</div>
                  </div>
                ))}
                {/* Total row */}
                <div style={{ display: 'flex', borderTop: '2px solid #ddd', fontWeight: 'bold', background: '#f9f9f9', padding: '8px 0', alignItems: 'center' }}>
                  <div style={{ flex: 2, padding: '8px' }}></div>
                  <div style={{ flex: 1, padding: '8px', textAlign: 'right' }}>Total:</div>
                  <div style={{ flex: 1, padding: '8px' }}>{`$${totalAmount.toFixed(2)}`}</div>
                  <div style={{ flex: 2, padding: '8px' }}></div>
                  <div style={{ flex: 2, padding: '8px' }}></div>
                </div>
                {/* Pagination controls */}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '16px' }}>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{ margin: '0 8px', padding: '4px 12px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                  >
                    Prev
                  </button>
                  <span style={{ margin: '0 8px' }}>
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    style={{ margin: '0 8px', padding: '4px 12px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                  >
                    Next
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default VoucherRequests;